import React from 'react'

const ServiceFormSuccess = () => {
  return (
    <div className='service-form__success alert alert-success my-4'>
        <h3 className='text-center'>Thanks!</h3>
        <p className='text-center'>We have received your Appointment Request. A Fraserway RV Service Representative will reach out to you to confirm your appointment shortly.</p>
    </div>
  )
}

export default ServiceFormSuccess